
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.986","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M13.222.014c.479.063.966.12 1.445.2a11.716 11.716 0 012.46.7c-.176.451-.352.888-.536 1.346a10.926 10.926 0 00-9.734.775 10.485 10.485 0 00-4.8 5.871A11.031 11.031 0 1021.32 5.953c-.049.367-.1.7-.148 1.064-.486-.063-.959-.127-1.445-.183.141-1.128.282-2.227.43-3.348H23.5v1.438h-1.073c.07.106.106.169.155.233a12.279 12.279 0 012.361 6.407c.007.07.028.141.042.211v1.515l-.042.211c-.106.655-.162 1.325-.31 1.966a12.441 12.441 0 01-9.966 9.339c-.465.078-.93.127-1.4.19h-1.511l-.211-.042c-.655-.1-1.325-.162-1.966-.31A12.512 12.512 0 01.191 14.65c-.078-.458-.127-.916-.19-1.374v-1.562c.063-.465.113-.93.19-1.4A12.482 12.482 0 0110.29.2c.472-.078.944-.134 1.424-.2.501.014 1.001.014 1.508.014z"}}),_c('path',{staticClass:"a",attrs:{"d":"M12.496 20.75a8.246 8.246 0 118.239-8.239 8.26 8.26 0 01-8.239 8.239zm3.376-9.05h-2.593V9.127h-1.565v4.151h4.158z"}})])
          )
        }
      }
    